import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

const CostCenterList = (props: PickerListProps<server.dto.CostCenter>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListCostCenterInstruction>({
    excludeKeys: [],
    page: 1,
    perPage: 20,
    visible: "onlyVisible",
    keyword: ""
  });

  const setFilter = (visible: server.dto.VisibleFilterSettings) => { setInstruction(instr => ({ ...instr, visible, page: 1 })); };

  return <PickerList
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="costCenters"
    api={window.CoreApi.CostCenter.ListCostCenter}
    onItemSelected={props.onItemSelected}
    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={cc => cc.costCenterId}
    renderListItem={cc => <>
      <div>{cc.internalId}</div>
      <SubLabel>{cc.title}</SubLabel>
    </>}

    filter1={{
      leftButton: {
        type: "primary",
        isActive: instruction.visible === "onlyVisible",
        label: RESX.SoUser.Active,
        onClick: () => { setFilter("onlyVisible"); }
      },
      rightButton: {
        type: "primary",
        isActive: instruction.visible === "onlyNotVisible",
        label: RESX.SoUser.Deactivated,
        onClick: () => { setFilter("onlyNotVisible"); }
      }
    }}
  />;
};

export default CostCenterList;